// 路由守卫
import { useContext } from 'react'
import { useLocation, Navigate } from 'react-router-dom'
import { UserContext } from "utils/getContext";
import { routeConfig } from './BaseRouter'

export const AuthRouter = ({ children }) => {
  const { search, pathname } = useLocation()
  //  从上下文中获取登录信息
  const { loginInfo, userInfo } = useContext(UserContext)
  const { loginUrl, requestParams, appContext } = loginInfo || {}
  const loginFlag = localStorage.getItem('isLogin') === 'true' ? true : false
  // 判断是否登录
  const isLogin = loginFlag ? userInfo ? true : false : false
  const isCheckLogin = sessionStorage.getItem('isCheckLogin') === 'true' ? true : false
  const route = routeConfig.find((item) => item.path === pathname) || {}
  const { requiresAuth } = route?.meta || {}

  // 如果isCheck不为true，则显示空白页面,避免页面闪烁
  if (!isCheckLogin && pathname !== '/checkLogin') {
    return null
  } else {
    // 判断当前路由是否需要访问权限
    if (requiresAuth) {
      // 判断是否登录
      // 从路由中获取是否登录的标识
      const urlLoginFlag = search.includes('loginFlag=true')
      const isLoginFlag = isLogin || urlLoginFlag
      // 如果需要登录，且未登录，则跳转到登录页
      if (!isLoginFlag) {
        // 获取route配置的路由
        const { path } = route
        // 获取当前的地址
        const locationOrigin = window.location.origin
        // 获取当前的context,APP的context,默认均为app
        // const context = window.location.pathname.split('/')[1]
        const context = appContext || '/app'
        const returnUrl = `returnurl=${locationOrigin}${context}/checkLogin?router=${path}`
        const login = `${loginUrl}${requestParams}&${returnUrl}`
        if (login) {
          window.location.href = encodeURI(login)
          return null
        } else {
          return <Navigate to="/home" />
        }
      } else {
        return children
      }
    } else {
      return children
    }
  }
}